import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import * as actions from "../../Store/Actions/index";
import "./orderSummary.css";
import Footer from "../../Components/Footer/Footer";
import vklogo from "../../assets/Images/vklogo.png";
import Axios from "../../axios-instance";
import CartItem from "../../Components/CartItems/CartItems";
import Breadcrumbs from "react-router-dynamic-breadcrumbs";
import { Link as Router } from "react-router-dom";
class Cart extends Component {
  state = {
    routes: {
      "/": "Home",
      "/cart": "Cart",
      "/cart/shipping": "Shipping",
      "/cart/shipping/ordersummary": "Order Summary",
    },
    totalamount: 0,
    cartDetails : [ ],
    cartAmount : 0,
    shippingCharges : 450
  };
  componentDidMount() {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
    let totalamount = 0;
    this.props.addedBooks.map((book) => {
      totalamount += Number(book.totalBookPrice);
    });
    this.setState({
      cartAmount : totalamount
    })
  }
  orderBookHandler = () => {
    const _vm = this.props;
    let totalamount = 0;
    this.props.addedBooks.map((book, index) => {
      totalamount += Number(book.totalBookPrice);
    });

    let payload = {
      books: this.props.addedBooks,
      address: this.props.userAddress,
      amount:
        this.props.userAddress.country === "India"
          ? totalamount
          : this.props.shipping,
      // book_medium_id : this.props.addedBooks.bmid
    };
    console.log(payload)
    this.props.orderBook(payload);
    var options = {
      key: "rzp_live_MdJPUOEM1dy6Jq", // Enter the Key ID generated from the Dashboard
      // amount: "100", // Amount is in currency subunits. Default currency is INR. Hence, 50000 means 50000 paise or ₹500.
      "amount": this.props.userAddress.country === 'India' ? totalamount*100 : this.props.shipping*100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 means 50000 paise or ₹500.
      currency: "INR",
      name: "Vk Global",
      image: vklogo,
      // "order_id": this.props.orderID.order_id,// Replace this with the order_id created using Orders API (https://razorpay.com/docs/api/orders).
      handler: function (response) {
        if (response.razorpay_payment_id) {
          let payload = {
            order_id: sessionStorage.getItem("orderID"),
            payment_id: response.razorpay_payment_id,
          };
          Axios.post("/update/vk/order", payload).then((localResponse) => {
            _vm.paymentSuccessHandler(localResponse.data);
            _vm.history.push("/orderplaced");
            _vm.initReducer();
            // this.props.history.push('/orderplaced')
          });
        } else {
          _vm.paymentSuccessHandler(response);
        }
      },
      prefill: {
        name: this.props.userAddress.name,
        email: this.props.userAddress.email,
        contact: this.props.userAddress.phone,
      },
      theme: {
        color: "#0a48a6",
      },
    };
    var rzp = new window.Razorpay(options);
    rzp.open();
  };
  
  render() {
  document.title = "VK Global Publications | Order Summary"

    // let total = 0;
    // this.props.addedBooks.map((book, index) => {
    //   total += Number(book.totalBookPrice);
    // });
    let shippingContainer;
    shippingContainer =
    this.props.userAddress.country !== 'India' ? (
        <div className="field-container cart-value">
          <div className="field-name">Shipping Charges</div>
          <div className="field-name">₹ {this.state.shippingCharges}</div>
        </div>
      ) : null
    return (
      <div>
        <div className="section2">
          <Container>
          <h3 className="  cataloguebreadcrumbs osCrumbs cartbread float-right">
                <Router>
                  <Breadcrumbs mappedRoutes={this.state.routes} />
                </Router>
              </h3>
            <h3 className="cart">Order Summary</h3>

            <div className="box-container">
              <Row className="cartRow">
                <Col className="cartbox-container" sm={8}>
                  <div className="boxCart">
                    <Row className="cartHeading">
                      <Col sm={6}>
                        <h3>Product</h3>
                      </Col>
                      <Col sm={3}>
                        <h3>Quantity</h3>
                      </Col>
                      <Col sm={3}>
                        <h3>Amount</h3>
                      </Col>
                    </Row>
                    <CartItem />
                  </div>
                </Col>
                <Col className="pricebox-container" sm={4}>
                  <div className="priceBox">
                    <h3>Billing Address</h3>

                    <div className="shippingDetail">
                      <p>
                        <i className="icon dripicons-home"></i>
                        {this.props.userAddress.address},{" "}
                        {this.props.userAddress.city},
                        {this.props.userAddress.state},
                        {this.props.userAddress.country}
                      </p>
                      <p>
                        <i className="icon dripicons-phone"></i>
                        {this.props.userAddress.phone}
                      </p>
                      <p>
                        <i className="icon dripicons-mail"></i>
                        {this.props.userAddress.email}
                      </p>
                    </div>
                    
                    <div className="content-container">
                      <div className="inner-div">
                    <h3>Cart Details</h3>

                        <div className="field-container cart-value">
                          <div className="field-name">Cart Value</div>
                          <div className="field-name">₹ {this.state.cartAmount}</div>
                        </div>
                        {shippingContainer}
                        <div className="field-container cart-value">
                          <div className="field-name">Total Cart Value </div>
                          <div className="field-name">
                            ₹ {this.props.userAddress.country !== "India" ? this.props.shipping: this.state.cartAmount}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="checkout orderBook"
                      onClick={this.orderBookHandler}
                    >
                      <button id="rzp-button1"> Confirm and Pay </button>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
          <Footer />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    addedBooks: state.book.addedBooks,
    orderID: state.book.orderID,
    userAddress: state.book.address,
    shipping: state.book.shippingCharge,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    orderBook: (cartItem) => dispatch(actions.orderBook(cartItem)),
    payment: () => dispatch(actions.initPayment()),
    paymentSuccessHandler: (status) => dispatch(actions.paymentSuccess(status)),
    initReducer: () => dispatch(actions.clearReducer()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Cart);
